/* The contents of this file are generated automatically during the build process of this component.
 * If you need to make changes on these styles, go to the .scss files of this repository.
 * Once you are done, run the "npm run build" script to update this file and commit your changes, including this file.
*/

import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const styleElement = document.createElement('dom-module');
styleElement.innerHTML =
    `<template>
<style>
/*CSS-START*/
:host {
  --font-family-base: var(--font-family-base-theme, Avenir);
  --font-family-light: var(--font-family-light-theme, AvenirLight);
  --font-family-heavy: var(--font-family-heavy-theme, AvenirHeavy);
  --font-family-black: var(--font-family-black-theme, AvenirBlack);
  --font-family-medium: var(--font-family-medium-theme, AvenirMedium);
  --font-family-roman: var(--font-family-roman-theme, AvenirRoman);
  --font-family-book: var(--font-family-book-theme, AvenirBook);
  --font-weight-light: var(--font-weight-light-theme, 100);
  --font-weight-heavy: var(--font-weight-heavy-theme, 700);
  --font-weight-black: var(--font-weight-black-theme, 900);
  --font-weight-medium: var(--font-weight-medium-theme, 400);
  --font-weight-roman: var(--font-weight-roman-theme, 400);
  --font-weight-book: var(--font-weight-book-theme, 400);
  --font50-line-height: var(--font50-line-height-theme, 60px);
  --font40-line-height: var(--font40-line-height-theme, 50px);
  --font36-line-height: var(--font36-line-height-theme, 48px);
  --font28-line-height: var(--font28-line-height-theme, 36px);
  --font24-line-height: var(--font24-line-height-theme, 32px);
  --font20-line-height: var(--font20-line-height-theme, 28px);
  --font18-line-height: var(--font18-line-height-theme, 26px);
  --font16-line-height: var(--font16-line-height-theme, 24px);
  --font14-line-height: var(--font14-line-height-theme, 20px);
  --font12-line-height: var(--font12-line-height-theme, 20px);
}

:host {
  --font-base: {
    font-family: var(--font-family-base);
  };
  --font-light: {
    font-family: var(--font-family-light);
    font-weight: var(--font-weight-light);
  };
  --font-heavy: {
    font-family: var(--font-family-heavy);
    font-weight: var(--font-weight-heavy);
  };
  --font-black: {
    font-family: var(--font-family-black);
    font-weight: var(--font-weight-black);
  };
  --font-medium: {
    font-family: var(--font-family-medium);
    font-weight: var(--font-weight-medium);
  };
  --font-roman: {
    font-family: var(--font-family-roman);
    font-weight: var(--font-weight-roman);
  };
  --font-book: {
    font-family: var(--font-family-book);
    font-weight: var(--font-weight-book);
  };
  --font50: {
    font-size: 50px;
    line-height: var(--font50-line-height);
  };
  --font40: {
    font-size: 40px;
    line-height: var(--font40-line-height);
  };
  --font36: {
    font-size: 36px;
    line-height: var(--font36-line-height);
  };
  --font28: {
    font-size: 28px;
    line-height: var(--font28-line-height);
  };
  --font24: {
    font-size: 24px;
    line-height: var(--font24-line-height);
  };
  --font20: {
    font-size: 20px;
    line-height: var(--font20-line-height);
  };
  --font18: {
    font-size: 18px;
    line-height: var(--font18-line-height);
  };
  --font16: {
    font-size: 16px;
    line-height: var(--font16-line-height);
  };
  --font14: {
    font-size: 14px;
    line-height: var(--font14-line-height);
  };
  --font12: {
    font-size: 12px;
    line-height: var(--font12-line-height);
  };
}

.font-base {
  font-family: var(--font-family-base);
}

.light {
  font-family: var(--font-family-light);
  font-weight: var(--font-weight-light);
}

.heavy {
  font-family: var(--font-family-heavy);
  font-weight: var(--font-weight-heavy);
}

.black {
  font-family: var(--font-family-black);
  font-weight: var(--font-weight-black);
}

.medium {
  font-family: var(--font-family-medium);
  font-weight: var(--font-weight-medium);
}

.roman {
  font-family: var(--font-family-roman);
  font-weight: var(--font-weight-roman);
}

.book {
  font-family: var(--font-family-book);
  font-weight: var(--font-weight-book);
}

.text-left {
  text-align: left;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.font50 {
  font-size: 50px;
  line-height: var(--font50-line-height);
}

.font40 {
  font-size: 40px;
  line-height: var(--font40-line-height);
}

.font36 {
  font-size: 36px;
  line-height: var(--font36-line-height);
}

.font28 {
  font-size: 28px;
  line-height: var(--font28-line-height);
}

.font24 {
  font-size: 24px;
  line-height: var(--font24-line-height);
}

.font20 {
  font-size: 20px;
  line-height: var(--font20-line-height);
}

.font18 {
  font-size: 18px;
  line-height: var(--font18-line-height);
}

.font16 {
  font-size: 16px;
  line-height: var(--font16-line-height);
}

.font14 {
  font-size: 14px;
  line-height: var(--font14-line-height);
}

.font12 {
  font-size: 12px;
  line-height: var(--font12-line-height);
}

.font-lg-1 {
  font-size: 50px;
  line-height: var(--font50-line-height);
}

.font-lg-2 {
  font-size: 40px;
  line-height: var(--font40-line-height);
}

.font-md-1 {
  font-size: 36px;
  line-height: var(--font36-line-height);
}

.font-sm-1 {
  font-size: 28px;
  line-height: var(--font28-line-height);
}

.font-sm-2 {
  font-size: 24px;
  line-height: var(--font24-line-height);
}

.font-sm-3 {
  font-size: 20px;
  line-height: var(--font20-line-height);
}

.font-sm-4 {
  font-size: 18px;
  line-height: var(--font18-line-height);
}

.font-sm-5 {
  font-size: 16px;
  line-height: var(--font16-line-height);
}

.font-sm-6 {
  font-size: 14px;
  line-height: var(--font14-line-height);
}

@media only screen and (min-width: 481px) and (max-width: 1179.98px) {
  .font-lg-1,
  .font-lg-2,
  .font-md-1 {
    font-size: 36px;
    line-height: var(--font36-line-height);
  }
  .font-sm-1 {
    font-size: 28px;
    line-height: var(--font28-line-height);
  }
  .font-sm-2 {
    font-size: 24px;
    line-height: var(--font24-line-height);
  }
  .font-sm-3 {
    font-size: 20px;
    line-height: var(--font20-line-height);
  }
  .font-sm-4 {
    font-size: 18px;
    line-height: var(--font18-line-height);
  }
  .font-sm-5 {
    font-size: 16px;
    line-height: var(--font16-line-height);
  }
  .font-sm-6 {
    font-size: 14px;
    line-height: var(--font14-line-height);
  }
}

@media only screen and (max-width: 480.98px) {
  .font-lg-1,
  .font-lg-2,
  .font-md-1,
  .font-sm-1 {
    font-size: 28px;
    line-height: var(--font28-line-height);
  }
  .font-sm-2 {
    font-size: 24px;
    line-height: var(--font24-line-height);
  }
  .font-sm-3 {
    font-size: 20px;
    line-height: var(--font20-line-height);
  }
  .font-sm-4 {
    font-size: 18px;
    line-height: var(--font18-line-height);
  }
  .font-sm-5 {
    font-size: 16px;
    line-height: var(--font16-line-height);
  }
  .font-sm-6 {
    font-size: 14px;
    line-height: var(--font14-line-height);
  }
}

:host {
  font-family: var(--font-family-base);
}
/*CSS-END*/
</style>
</template>`;

styleElement.register('wdpr-avenir-typography');
